<template>
    <div :class="['multiColumnar-container' , isActiveDetailedView ? 'column' : '']">
        <div v-for="content in bodyContent" :key="content.title" class="card-container">
            <SaiCard v-if="content.section !== 'lawlex_blank'">
                <div slot="card-header">
                    <template v-if="isLawlexTitle(content.title)">
                        <div class="lawlex-card-header">
                            <div class="lawlex-left">
                                <span class="lawlex-label">Lawlex</span>
                                <span class="lawlex-badge" :class="lawlexRegion(content.title)?.toLowerCase()">{{ lawlexRegion(content.title) }}</span>
                            </div>
                            <div class="lawlex-right">{{ lawlexHeaderTitle(content.title) }}</div>
                        </div>
                    </template>
                    <template v-else>
                        <span>
                            <i :class="content.icon"></i>
                        </span>
                        <span>{{$t(content.title)}}</span>
                    </template>
                </div>
                <div slot="card-body" >
                    <template v-if="lawlexTitles.includes(content.title)">
                        <LawlexAccordion :content="content" />
                    </template>
                    <template v-else>
                        <div v-for="subContent in content.subContent" :key="subContent.id">

                        <template  v-if="isActiveDetailedView">
                            <ColumnarContent :headerContent="subContent.headers"
                                            :bodyContent="subContent.content"
                                            class="accordion-content"/>
                        </template>

                        <template v-else>
                            <div v-for="element in subContent.content" :key="element" class="compact-content-container">
                                <div v-for="name in element" :key="name">
                                    <a :href="name.linkURL">
                                        {{name.linkName}}
                                    </a>
                                    <template v-if="name.actions">
                                        <template v-if="'type' in name && name.type=='favourite'">
                                            <EditFavourite :id="name.actions.id" :name="name.linkName"/>
                                        </template>
                                        <template v-else>
                                        <EditSavedSearch :id="name.actions.id" :name="name.linkName" :notify="(name.notify.toString() == '1')" :details="name.details"/>
                                        </template>
                                    </template>
                                </div>
                            </div>
                        </template>

                        </div>
                    </template>

                </div>
            </SaiCard>
            <div class="lawlex-blank" v-else>
            </div>
        </div>
    </div>
</template>

<script>
import SaiCard from "@/components/common/SaiCard";
import ColumnarContent from "@/components/QuickViews/AccordionContent/ColumnarContent";
import EditSavedSearch from "@/components/QuickViews/EditSavedSearch";
import EditFavourite from "@/components/QuickViews/EditFavourite";
import LawlexAccordion from "@/components/QuickViews/AccordionContent/Lawlex/LawlexAccordion.vue";
import i18n from "@/plugins/i18n";
import { LAWLEXAU, LAWLEXEU, LAWLEXUS } from "../constant";

const LAWLEX_TITLES = [
    'home_legislation_lawlexau_recent_search',
    'home_legislation_lawlexeu_saved_search',
    'home_legislation_lawlexus_saved_search'
];
export default {
    name: "MultiColumnarContent",
    components: {
        SaiCard,
        ColumnarContent,
        EditSavedSearch,
        EditFavourite,
        LawlexAccordion,
    },
    props: {
        bodyContent: { type: Array, default: () => [] },
        settings: { type: Object, default: () => [] },
        isLegislationContent: { type: Boolean, default: () => false},
    },
    computed: {
        isActiveDetailedView() {
            return this.settings && this.settings['viewMode']
        },
        lawlexTitles() {
            return LAWLEX_TITLES;
        }
    },
    methods: {
        isLawlexTitle(title) {
            return this.lawlexTitles.includes(title);
        },
        lawlexRegion(title) {
            if (title.includes(LAWLEXAU)) {
                return 'AU';
            }
            if (title.includes(LAWLEXEU)) {
                return 'EU';
            }
            if (title.includes(LAWLEXUS)) {
                return 'US';
            }
            return '';
        },
        lawlexHeaderTitle(title) {
            const translated = i18n.t(title);
            const withoutPrefix = translated.replace(/Lawlex (AU|EU|US)/g, '').replace(/\s+/g, ' ').trim();
            if (title.includes('saved_search')) {
                return withoutPrefix.replace(/^Legislation\\s+/i, '').trim();
            }
            return withoutPrefix;
        }
    },
}
</script>

